export default "__VITE_ASSET__DXWztRwV__"